<template>
  <div>
    <group-card title="Credit Report Rules" icon="traffic" padded>
        <data-table
          :headers="headers"
          v-model="vedaRules"
          :items-per-page="50"
          filterable
          editable-columns
          title="Credit Report Traffic Light Rules"
        >
        </data-table>
    </group-card>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import { GroupCard } from "@/components";

export default {
  components: {
    DataTable,
    GroupCard
  },
  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
          sort: true,
          width: '105px',
          search: true,
        },
        {
          text: "Rule Name",
          value: "rule_name",
          sort: true,
          search: true,
        },
        {
          text: "Rule Property",
          value: "rule_property",
          sort: false,
          search: false,
          break_lines: true
        },
        {
          text: "Rule Comparison",
          value: "rule_comparison",
          sort: false,
          search: true,
          break_lines: true
        },
        {
          text: "Rule Value",
          value: "rule_value",
          sort: false,
          search: true,
          break_lines: true
        },
        {
          text: "Traffic Light Colour",
          value: "rule_traffic_light",
          sort: true,
          search: true,
        }
      ],
      vedaRules: [],
    }
  },
  methods: {
    async getVedaRules () {
      this.vedaRules = await this.$store.dispatch('fetch_administration_veda_rules');
    }
  },
  created () {
    this.getVedaRules();
  },
}
</script>
